import fetchival from 'fetchival';
import apiConfig from '../../config/apiConfig';

export default () => ({
  fetch: fetchival(apiConfig.root, {
    credentials: 'include',
  }),

  /**
   * Iniciar sesion
   */
  signIn ({ email, password }) {
    return this.fetch(apiConfig.signIn).post({
      sp_card: email,
      nip: password,
    });
  },

  /**
   * Crear cuenta
   */
  signUp ({ firstName, lastName, email, emailConfirmation }) {
    return this.fetch(apiConfig.signUp).post({
      first_name: firstName,
      last_name: lastName,
      email,
      email_confirmation: emailConfirmation,
    });
  },

  /**
   * Cierra sesión
   */
  signOut () {
    return this.fetch(apiConfig.signOut).delete();
  },

  /**
   * Obtiene el perfil del usuario
   */
  getProfile () {
    return this.fetch(apiConfig.getProfile).get();
  },

  /**
   * Recuperar pin
   */
  forgotPin (email) {
    return this.fetch(apiConfig.forgotPin).post({ email });
  },
});



// WEBPACK FOOTER //
// ./utils/getSession.js